<template>
  <div class="infoForm-wrap">
    <el-form
      class="form"
      :model="formData"
      :rules="fromRule"
      ref="infoForm"
      :label-position="labelPosition"
    >
      <!-- <span>{{JSON.stringify(formTitle)}}</span> -->
      <template v-for="(item, index) in formTitle">
        <!-- 表单内容 -->
        <!-- isShowName/isShowVal用来关联显示 -->
        <template
          v-if="(!item.isShowName&&!item.hasShowName) || (item.isShowName && typeof(item.isShowVal) != 'undefined' && (Array.isArray(item.isShowVal) ? item.isShowVal.includes(formData[item.isShowName]) : formData[item.isShowName] == item.isShowVal))||(item.hasShowName&&formData[item.hasShowName] != null &&formData[item.hasShowName] != '')"
        >
          <!-- 标题 -->
          <div class="title" v-if="item.type==='title'">{{item.text}}</div>
          <!-- 表单内容 -->
          <el-form-item
            v-else
            :label="labelN ? item.label : item.label+':'"
            :label-width="item.labelW || formLabelWidth"
            :prop="item.prop"
            :class="{'underline' : underLine}"
            :style="{width: item.width ? item.width : type == 'search' ? 'auto' : '45%'}"
          >
            <!-- 文本展示 -->
            <template v-if="item.type==='view'">
              <!-- 多选 -->
              <template v-if="Array.isArray(formData[item.prop]) && item.viewFor">
                <div
                  class="value"
                  v-for="(val, index) in formData[item.prop]"
                  :key="val"
                >{{index+1}}、{{item.viewFor(val)}}</div>
              </template>
              <!-- 上传内容 -->
              <template v-if="Array.isArray(formData[item.prop]) && !item.format">
                <a
                  class="nofile"
                  v-if="formData[item.prop][0]"
                  :href="formData[item.prop][0].url"
                >{{formData[item.prop][0].name}}</a>
                <span v-else class="nofile">未上传文件资料</span>
              </template>
              <!-- 下拉/单选等有format的情况 -->
              <span v-else-if="item.format && !item.dynamic" class="value">{{item.format(formData)}}</span>
              <!-- 数据复杂格式化 -->
              <span v-else-if="item.dynamic" class="value">{{item.format(formData[item.prop])}}</span>
              <!-- 文本 -->
              <span v-else class="value">{{formData[item.prop]}}</span>
            </template>
            <!-- 富文本 -->
            <template v-if="item.type==='editText'">
              <!-- 审核公共 -->
              <editor
                v-if="item.public"
                v-model="auditData.content"
                :height="item.height"
                :disable="item.editTextDisable"
              ></editor>
              <!-- 其他 -->
              <editor
                v-else
                v-model="formData[item.prop]"
                :height="item.height"
                :disable="item.editTextDisable"
              ></editor>
            </template>
            <!-- 多行文本框 -->
            <template v-if="item.prop==='orgAddress'">
              <el-input
                v-model="formData[item.prop]"
                type="input"
                style="width:70%!important;"
              >
                <el-button  slot="append" style="color:#126df7" icon="el-icon-location" @click="highSearch(item.eventName)"></el-button>
              </el-input>

            </template>
            <!-- 单行文本框 -->
            <el-input
              :class="{'search-high':item.search}"
              v-if="item.type==='input'"
              v-model="formData[item.prop]"
              autocomplete="off"
              :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
              :disabled="item.disabled"
              :readonly="item.readonly"
              :placeholder="item.placeholder || '请输入内容'"
            ></el-input>
            <el-input-number v-if="item.type=='number'" v-model="formData[item.prop]" label="请输入楼层" :disabled="item.disabled"></el-input-number>
            <div v-if="item.type==='section'" class="section">
              <el-input
                v-model="formData[item.propStart]"
                autocomplete="off"
                :style="{width: item.inputW+'!important'}"
                :disabled="item.disabled"
                :readonly="item.readonly"
              ></el-input>
              <span>—</span>
              <el-input
                v-model="formData[item.propEnd]"
                autocomplete="off"
                :style="{width: item.inputW+'!important'}"
                :disabled="item.disabled"
                :readonly="item.readonly"
              ></el-input>
            </div>

            <!-- 多行文本框 -->
            <el-input
              v-if="item.type==='textarea' && item.prop!=='orgAddress'"
              v-model="formData[item.prop]"
              type="textarea"
            ></el-input>
            <!-- 下拉框  -->
            <template v-if="item.type==='select'">
              <!-- 审核公共 -->
              <el-select
                v-if="item.public"
                v-model="auditData.option"
                placeholder="请选择"
                :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
              >
                <el-option
                  v-for="val in item.options"
                  :label="val.label"
                  :value="val.data"
                  :key="val.label"
                ></el-option>
              </el-select>
              <!-- 地址下拉框 -->
               <el-select
                v-if="item.address"
                 filterable
                no-data-text="加载中......."
                v-model="formData[item.prop]"
                @change="selectChange(item.changeEvent || null, formData[item.prop]) "
                :disabled="item.isDisabled || (item.isDisableName && (Array.isArray(item.isDisableVal) ? item.isDisableVal.includes(formData[item.isDisableName]) : formData[item.isDisableName] == item.isDisableVal))"
                placeholder="请选择"
                :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
              >
                 <el-option
                  v-for="(val,index) in item.options"
                  :label="val.label"
                  :value="val.data"
                  :key="index"
                ></el-option>
              </el-select>
              <!-- 其他 -->
              <el-select
                v-else
                filterable
                v-model="formData[item.prop]"
                @change="selectChange(item.changeEvent || null, formData[item.prop]) "
                :disabled="item.isDisabled || (item.isDisableName && (Array.isArray(item.isDisableVal) ? item.isDisableVal.includes(formData[item.isDisableName]) : formData[item.isDisableName] == item.isDisableVal))"
                placeholder="请选择"
                :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
              >
                <el-option
                  v-for="(val,index) in item.options"
                  :label="val.label"
                  :value="val.data"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
            <!-- 单选 -->
            <el-radio-group v-if="item.type==='radio'" v-model="formData[item.prop]">
              <el-radio v-for="val in item.options" :label="val.data" :key="val.label">{{val.label}}</el-radio>
            </el-radio-group>
            <!-- 多选 -->
            <el-checkbox-group v-if="item.type==='checkbox'" v-model="formData[item.prop]" >
              <el-checkbox
                v-for="(val, index) in item.options"
                :label="val.data"
                :key="index"
                :disabled="item.disabled"
                :true-label="item.trueLabel"
                :false-label="item.falseLabel"
              >{{val.label}}</el-checkbox>
            </el-checkbox-group>
            <!-- Switch开关 -->
            <el-switch
              v-model="formData[item.prop]"
              v-if="item.type==='switch'"
              active-color="#13ce66"
              inactive-color="#ddd"
              @change="setchange"
              :active-value="item.activeValue || '02'"
              :inactive-value="item.inactiveValue || '01'"
              active-text="长期"
            ></el-switch>
            <el-date-picker
              v-if="item.type==='datetime'"
              type="datetime"
              :disabled="item.disabled"
              v-model="formData[item.prop]"
              placeholder="请选择时间"
              :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
            ></el-date-picker>
            <!-- slider滑块 -->
            <el-slider
              v-if="item.type==='slider'"
              v-model="formData[item.prop]"
              style="width: 300px;"
            ></el-slider>
            <!-- 时间选择器 -->
            <el-time-picker
              v-if="item.type==='time'"
              v-model="formData[item.prop]"
              placeholder="请选择时间"
              :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
            ></el-time-picker>
            <!-- 日期选择器 -->
            <el-date-picker
              v-if="item.type==='date'"
              v-model="formData[item.prop]"
              align="right"
              type="date"
              placeholder="请选择日期"
              :style="{width: type == 'search' ? '100% !important' : '80% !important'}"
            ></el-date-picker>
            <!-- 日期区间选择器 -->
            <el-date-picker
              v-if="item.type==='dateRange'"
              v-model="formData[item.prop]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <!-- 日期区间选择器时间 -->
            <el-date-picker
              v-if="item.type==='datetimerange'"
              v-model="formData[item.prop]"
              :disabled="item.disabled"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <!-- 上传单张图片 -->
            <div v-if="item.type==='imgUpload'">
              <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :action="item.action"
                :on-success="pictureAddSuccess"
                :auto-upload="true"
                :name="item.fileName || 'file'">
                <img v-if="formData[item.prop]" :src="formData[item.prop]" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <!-- 附件上传 -->
            <div v-if="item.type==='upload'" class="material" @click="confirmFile(item.prop)">
              <!-- <span class="label">附件:</span> -->
              <span class="type">{{item.name}}</span>
              <el-upload
                ref="upload"
                :limit="item.limit"
                :action="item.action"
                :auto-upload="item.autoUpload"
                :on-remove="fileRemove"
                :on-change="fileChange"
                :on-success="fileSuccess"
                :on-error="fileError"
                :before-upload="beforeUpload"
                :file-list="item.public ? auditData[item.prop] : formData[item.prop]"
              >
                <el-button
                  style="display: inline-block"
                  slot="trigger"
                  size="small"
                  type="primary"
                >选取文件</el-button>
                <span
                  class="nofile"
                  v-show="item.public ? !auditData[item.prop] || (auditData[item.prop] && auditData[item.prop].length == 0) : !formData[item.prop] || (formData[item.prop] && formData[item.prop].length == 0)"
                >未上传文件资料</span>
              </el-upload>
            </div>
            <div v-else-if="item.type==='uploadImage'" class="material materialImage"  @click="confirmFile(item.prop)">
              <el-upload
                class="avatar-uploader"
                ref="upload"
                :action="item.action"
                :auto-upload="item.autoUpload"
                :name="item.name"
                :show-file-list="false"
                :on-change="fileChange"
                :on-success="fileSuccess"
              >
              <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <i class="el-icon-plus avatar-uploader-icon"></i>
               <img  :src="formData[item.prop]" class="avatar" style="position:absolute;left:0;top:0">
              <!-- <img v-show="formData[item.imgSrcFlag]" :src="formData[item.imgSrcFlag]" class="avatar" style="position:absolute;left:0;top:0"> -->
            </el-upload>
            <span>图片建议600px*200px，不超过500K</span>
            </div>
            <!-- 省市区三级联动 -->
            <div class="area" v-if="item.type=='area'">
              <el-cascader
                style="width: 80%;"
                v-model="formData[item.areaStart]"
                :options="addressList"
                :props="addressProps"
                @change="areaChange"
              ></el-cascader>
              <el-input
                @input="areaChange(formData[item.areaEnd])"
                v-model="formData[item.areaEnd]"
                type="textarea"
                style="width:80%;margin-top:20px;"
                placeholder="请输入街道门牌号"
              ></el-input>
            </div>
           <el-select v-if="item.type==='allSelect'"
               v-model="formData[item.prop]"
               multiple
               filterable
               remote
               reserve-keyword
               placeholder="请输入关键词"
               @change="$forceUpdate()"
               :remote-method="requestOrg">
                <el-option
                  v-for="(val,index) in item.options"
                  :label="val.label"
                  :value="val.data"
                  :key="val.data"
                ></el-option>
            </el-select>
            <!-- 提示信息 -->
            <el-tooltip
              v-if="item.tip"
              class="item"
              effect="dark"
              :content="item.tip"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            <div
              class="highSearch"
              :style="{right: item.posRight ? item.posRight : '20px'}"
              v-if="item.search && item.type !== 'view'"
              @click="highSearch(item.serachEventName)"
            >高级选择</div>
          </el-form-item>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import Editor from '../editor'
import { regionData } from 'element-china-area-data'
import { copy } from 'common/js/util.js'
export default {
  props: {
    // 模式: search搜索 / form表单
    type: String,
    // 表单格式描述
    formTitle: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 表单校验规则
    fromRule: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 操作框前文字的宽度
    formLabelWidth: {
      type: String,
      default: '100px'
    },
    // 公共审核内容
    auditData: {
      type: Object,
      default: () => {
        return null
      }
    },
    // label标签对齐位置
    labelPosition: {
      type: String,
      default: 'right'
    },
    // label标签是否带":"
    labelN: {
      type: Boolean,
      default: false
    },
    // 每一个item是否带下划线
    underLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // options: this.addressList, // 省市区数据
      selectedOptions: [], // 选中的地区
      addressProps: {
        value: 'id',
        label: 'name',
        children: 'childrenList'
      },
      // 哪个文件正在发生操作
      fileProp: '',
      // 表单内容校验是否通过
      isValid: false,
      imageUrl: ''
      //   formLabelWidth: '90px',
      //   表单内容描述
      //   formTitle: [
      //     {
      //       type: 'input',
      //       label: '单行文本',
      //       prop: 'a'
      //     },{
      //       type: 'textarea',
      //       label: '多行文本',
      //       prop: 'b'
      //     },{
      //       type: 'select',
      //       label: '下拉框',
      //       prop: 'c',
      //       options: [{
      //           label: '选项1',
      //           data: '1'
      //       },{
      //           label: '选项2',
      //           data: '2'
      //       }]
      //     },{
      //       type: 'radio',
      //       label: '单选',
      //       prop: 'd',
      //       options: [{
      //           label: '选项1',
      //           data: '1'
      //       },{
      //           label: '选项2',
      //           data: '2'
      //       }]
      //     },{
      //       type: 'checkbox',
      //       label: '多选',
      //       prop: 'e',
      //       options: [{
      //           label: '选项1',
      //           data: '1'
      //       },{
      //           label: '选项2',
      //           data: '2'
      //       }]
      //     },{
      //       type: 'switch',
      //       label: 'Switch开关',
      //       prop: 'f'
      //     },{
      //       type: 'slider',
      //       label: 'slider滑块',
      //       prop: 'g'
      //     },{
      //       type: 'time',
      //       label: '时间选择',
      //       prop: 'h'
      //     },{
      //       type: 'date',
      //       label: '日期选择',
      //       prop: 'i'
      //     }
      //   ],
      //   表单内容
      //   formData: {
      //       a: '我是单行文本',
      //       b: '我是多行文本',
      //       c: '1',
      //       d: '1',
      //       e: ['1'],
      //       f: true,
      //       g: 50,
      //       h: new Date(2016, 9, 10, 18, 40),
      //       i: new Date(2016, 9, 10, 18, 40)
      //   },
      // 表单规则校验
      //   rules: {
      //     name: [{ required: true, message: '请输入名字', trigger: 'blur' }]
      //   }
    }
  },
  components: {
    Editor
  },
  created() {
    // 获取地址JSON
    // this.getAreaList()
  },
  computed: {
    ...mapGetters(['addressList'])
  },
  methods: {
    // 图片上传成功
    pictureAddSuccess(res, file) {
      this.$emit('pictureAddSuccess', res)
    },
    // 获取地址JSON
    async getAreaList() {
      if (this.addressList) {
        // console.log('this.addressList', this.addressList)
        return
      }
      await this.$apiData.addressJson().then(res => {
        if (res && res.data.code == '0000') {
            this.upAddressList(JSON.parse(res.data.regionStr))
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 表单内容校验
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.infoForm.validate(valid => {
          resolve(valid)
        })
      })
    },
    // 文件移除
    fileRemove(file, fileList) {
      setTimeout(() => {
        this.$emit('fileRemove', file, fileList, this.fileProp)
      }, 0)
    },
    // 文件选取
    fileChange(file, fileList) {
      setTimeout(() => {
          this.imageUrl = URL.createObjectURL(file.raw);
          this.$emit('fileChange', file, fileList, this.fileProp)
      }, 0)

    },
    // 文件上传成功
    fileSuccess(res, file, fileList) {
      this.$emit('fileSuccess', res, file, this.fileProp)
    },
    // 文件上传失败
    fileError(err, file, fileList) {
      this.$emit('fileError', res, file, this.fileProp)
    },
    // 文件上传前
    beforeUpload(file) {
      this.$emit('beforeUpload', file)
    },
    // 下拉框内容变化
    selectChange(eventName, data) {
      console.log("selectChange~~~~~~~~~~~")
      if (eventName) {
        this.$emit(eventName, copy(data))
      }
    },
    setchange(data){
      this.$emit('switchChange', data)
    },
    // 地区变化
    areaChange(data) {
      this.$emit('areaChange', data)
    },
    // 确定是哪个文件发生操作
    confirmFile(prop) {
      this.fileProp = prop
    },
    // 内容填充高级搜索
    highSearch(eventName) {
      console.log('!!!!', eventName)
      this.$emit(eventName)
    },
    //搜索小区
    requestOrg(key) {
      this.$emit('requestSearchOrg', key)
    },
    ...mapMutations({
      upAddressList: 'upAddressList',
    })
  }
}
</script>
<style lang='scss' scoped>
.form {
  text-align: left;
  & >>> .el-select .el-input {
    width: 100% !important;
  }
}
.title {
  height: 25px;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.el-form-item {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}
.value {
  color: #000;
}
.tip {
  color: #999;
}
.material {
  margin-bottom: 20px;
  .label,
  .type {
    margin-right: 30px;
  }
  & >>> div,
  & >>> ul {
    display: inline-block;
    vertical-align: middle;
  }
  & >>> ul {
    margin-left: 100px;
  }
  & >>> li {
    margin-top: 0;
  }
}
.materialImage{
  margin-bottom: 0;
  // & >>> div{
  //   height: 81px;
  //   line-height: 91px;
  // }
}
.underline {
  position: relative;
  &:after {
    content: '';
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 0;
    height: 1px;
    margin-left: -18px;
    background-color: #e5e5e5;
  }
}
.nofile {
  vertical-align: middle;
  margin-left: 100px;
}
.highSearch {
  position: absolute;
  top: 0;
  // right: 20px;
  cursor: pointer;
  color: #FF8C42;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #FF8C42;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/base/form/index.vue